import { apiRequest } from "@/api";

const state = {
  store: {},
};

const mutations = {
  SET_STORE_CONFIG: (state, store) => {
    // console.log("store of chat config: ", store);
    state.store = store;
  },
  SET_STORE_CONFIG_CHAT_CONFIG: (state, chat_config) => {
    if (chat_config) state.store.chat_config = chat_config;
  },
};

const actions = {
  FETCH_STORE_CONFIG: async ({ rootState, commit }) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .get("store_config/fetchConfig")
        .then(({ data }) => {
          data.response.chat_config.storeId = rootState.admin.storeId;
          if (
            !!data.response?.details?.store_with_authentication === true &&
            !rootState.app_drawer_links.find(
              (link) => link.to === "/AuthOptionEmailList"
            )
          ) {
            rootState.app_drawer_links.push({
              to: "/AuthOptionEmailList",
              icon: "mdi-list-box",
              text: "auth_email_list",
            });
          }

          commit("SET_STORE_CONFIG", data.response);
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  UPDATE_AUTO_MODE: async ({ state }, { time_configuration }) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .post("store_config/UpdateAutoModeTime", { time_configuration })
        .then(({ data }) => {
          state.store.chat_config.auto.time_configuration = time_configuration;
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  UPDATE_STATE_CHAR_DATE: async ({ state }, { time_configuration }) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .post("store_config/UpdateStateChatTime", { time_configuration })
        .then(({ data }) => {
          state.store.chat_config.chat_state.time_configuration = time_configuration;
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  UPDATE_STORE_CONFIG: ({ state }, params) =>
    new Promise((resolve, reject) => {
      return apiRequest()
        .post("store_config/update", params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),
  UPDATE_CHAT_CONFIG: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      return apiRequest()
        .post("store_config/update_chat_config", params)
        .then(({ data }) => {
          commit("SET_STORE_CONFIG_CHAT_CONFIG", data?.new_config?.chat_config);
          resolve(data?.new_config?.chat_config);
        })
        .catch((e) => {
          reject(e);
        });
    }),
  CHANGE_MATOMO_ENABLE_STATE: ({ commit, state }, { matomo_activated }) =>
    new Promise((resolve, reject) => {
      return apiRequest()
        .post("store_config/update_matomo_activated", { matomo_activated })
        .then(({ data }) => {
          commit("SET_STORE_CONFIG", {
            ...state.store,
            details: data.details,
          });
          resolve(data.details);
        })
        .catch((e) => {
          reject(e);
        });
    }),
};

export default { state, mutations, actions };
